import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { ReferenceSyncBlockStoreManager } from './referenceSyncBlockStoreManager';
import { SourceSyncBlockStoreManager } from './sourceSyncBlockStoreManager';

// A parent store manager responsible for the lifecycle and state management of sync blocks in an editor instance.
// Contains two child store managers: ReferenceSyncBlockStoreManager and SourceSyncBlockStoreManager.
// ReferenceSyncBlockStoreManager is responsible for the lifecycle and state management of reference sync blocks in an editor instance.
// SourceSyncBlockStoreManager is responsible for the lifecycle and state management of source sync blocks in an editor instance.
// Can be used in both editor and renderer contexts.
export var SyncBlockStoreManager = /*#__PURE__*/function () {
  function SyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, SyncBlockStoreManager);
    // In future, if reference manager needs to reach to source manager and read it's current in memorey cache
    // we can pass the source manager as a parameter to the reference manager constructor
    this.sourceSyncBlockStoreManager = new SourceSyncBlockStoreManager(dataProvider);
    this.referenceSyncBlockStoreManager = new ReferenceSyncBlockStoreManager(dataProvider);
  }
  return _createClass(SyncBlockStoreManager, [{
    key: "referenceManager",
    get: function get() {
      return this.referenceSyncBlockStoreManager;
    }
  }, {
    key: "sourceManager",
    get: function get() {
      return this.sourceSyncBlockStoreManager;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.referenceSyncBlockStoreManager.destroy();
      this.sourceSyncBlockStoreManager.destroy();
    }
  }]);
}();